<template>
  <div class="layout-wrapper">
    <!-- header 部分 -->
    <common-head></common-head>
    <!-- 二级路由入口显示地方 -->
    <router-view></router-view>
    <!-- footer部分 -->
    <common-footer></common-footer>
  </div>
</template>
<script>
import CommonHead from '@/components/CommonHead'
import CommonFooter from '@/components/CommonFooter'
export default {
  name: 'Layout',
  data () {
    return {

    }
  },
  components: {
    CommonHead,
    CommonFooter
  },
  watch: {
    $route (val) {
      console.log(val, 'route')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/index.vue